export default __webpack_public_path__ + "static/media/Poppins-Black.eb12e137.woff";